import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext();

export const translations = {
  en: {
    about: "About",
    skills: "Skills",
    experience: "Experience",
    projects: "Projects",
    education: "Education",
    contact: "Contact",
    githubProfile: "Github Profile",
    heroGreeting: "Hi, I am",
    iAmA: "I am a",
    checkResume: "Resume (EN)",
    checkResumeFr: "Resume (FR)",
    skillsDesc: "Here are the technologies I work with on a daily basis",
    experienceTitle: "Experience",
    experienceDesc: "My professional journey building production applications",
    projectsTitle: "Projects",
    projectsDesc: "A selection of production apps, open-source contributions, and side projects",
    educationTitle: "Education & Certifications",
    educationDesc: "My academic background and professional certifications",
    contactTitle: "Contact",
    contactDesc: "Feel free to reach out to me for any questions or opportunities!",
    emailMe: "Email Me 🚀",
    yourEmail: "Your Email",
    yourName: "Your Name",
    subject: "Subject",
    message: "Message",
    send: "Send",
    emailSent: "Email sent successfully!",
    allProjects: "All",
    mobileProjects: "Mobile",
    webProjects: "Web",
    otherProjects: "Others",
    openSource: "Open Source",
    viewCode: "View Code",
    viewLive: "View Live",
    certifications: "Certifications",
  },
  fr: {
    about: "Profil",
    skills: "Compétences",
    experience: "Expérience",
    projects: "Projets",
    education: "Formation",
    contact: "Contact",
    githubProfile: "Profil Github",
    heroGreeting: "Salut, je suis",
    iAmA: "Je suis",
    checkResume: "CV (EN)",
    checkResumeFr: "CV (FR)",
    skillsDesc: "Voici les technologies avec lesquelles je travaille au quotidien",
    experienceTitle: "Expérience",
    experienceDesc: "Mon parcours professionnel de développement d'applications en production",
    projectsTitle: "Projets",
    projectsDesc: "Une sélection d'apps en production, contributions open-source et projets personnels",
    educationTitle: "Formation & Certifications",
    educationDesc: "Mon parcours académique et mes certifications professionnelles",
    contactTitle: "Contact",
    contactDesc: "N'hésitez pas à me contacter pour toute question ou opportunité !",
    emailMe: "Envoyez-moi un email 🚀",
    yourEmail: "Votre Email",
    yourName: "Votre Nom",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer",
    emailSent: "Email envoyé avec succès !",
    allProjects: "Tous",
    mobileProjects: "Mobile",
    webProjects: "Web",
    otherProjects: "Autres",
    openSource: "Open Source",
    viewCode: "Voir le Code",
    viewLive: "Voir en Direct",
    certifications: "Certifications",
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const browserLang = navigator.language || navigator.userLanguage;
    return browserLang.startsWith("fr") ? "fr" : "en";
  });

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "fr" : "en"));
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
